import { Fragment } from "react";

import useNTGroupAthleteApprovalModal from "./UseNTGroupAthleteApprovalModal";

import NTGroupContactApprovalFormGrid from "../../grids/contactApprovalForm/NTGroupContactApprovalFormGrid";

import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import ExclamationIcon from "@usas/ui-web/components/icons/ExclamationIcon";
import InGoodStandingIcon from "@usas/ui-web/components/icons/InGoodStandingIcon";

import { SAVING_MSG } from "@usas/ui-web/utils/Constants";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const NTGroupAthleteApprovalModal = ({ memberObj, onCloseModal }) => {
  const {
    isSaving,
    isLoading,
    gridData,
    coachNotListed,
    onSubmitContactInfoFormGrid
  } = useNTGroupAthleteApprovalModal(memberObj, onCloseModal);

  return (
    <Fragment>
      <PopUpModal
        widthPct={99}
        maxWidth={1080}
        title={'Approve Contact Info'}
        displayPopUp={isSaving !== true}
        onModalCanceled={onCloseModal}>
        <div className="row">
          <div className="col-xs-12 usas-extra-bottom-margin">
            <p className={global.HeaderText}><strong>Member Name:</strong>&nbsp;{memberObj.groupMemberName || ''}</p>
            <p className={global.HeaderText}><strong>Member Id:</strong>&nbsp;{memberObj.memberId || ''}</p>
            <p className={global.HeaderText}><strong>Coach Not Listed:</strong>&nbsp;{coachNotListed ? <span><span className={global.WarningMessage}><ExclamationIcon toolTipText="User marked a coach as not listed" /></span> Yes</span> : <span><InGoodStandingIcon toolTipText="User did not mark a coach as not listed" /> No</span>}</p>
          </div>
        </div>
        <NTGroupContactApprovalFormGrid
          isLoading={isLoading}
          gridData={gridData}
          onSubmitFormCallback={onSubmitContactInfoFormGrid}
          onSecondaryButtonClicked={onCloseModal} />
      </PopUpModal>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={SAVING_MSG}
        displayPopUp={isSaving} />
    </Fragment>
  );
};

export default NTGroupAthleteApprovalModal;